const areTwoArraysEqual = (a, b) => { //result is calculated without considering index of each item
    if (a.length === 0 && b.length === 0) {
        return true;
    }

    if (a.length !== b.length) {
        return false;
    }

    let result = false;

    for (let i = 0; i < a.length; i++) {
        if (!b.includes(a[i])) {
            return false;
        } else {
            result = true;
        }
    }
    return result;
}

export default areTwoArraysEqual;